module.exports = "/assets/data/e2260f785d796297d541c83727dd9de5-NP10.data.json";